import React from "react";

import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import Box from "@mui/material/Box";
import CalculateIcon from '@mui/icons-material/Calculate';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import PollIcon from '@mui/icons-material/Poll';
import SellIcon from '@mui/icons-material/Sell';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

// const steps = ['Add a product', 'Create Value Model', 'Set up Survey', 'Forecast Costs'];
const steps = ['Add a product', 'Create Value Model', 'Generate Presentation'];

function CustomStepIcon({ active, index }) {
    // Render different icons for each step
    switch (index) {
        case 0:
            return <SellIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
        case 1:
            return <CalculateIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
        case 2:
            return <AutoGraphIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
        // case 2:
        //     return <PollIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
        // case 3:
        //     return <MonetizationOnIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
        default:
            return null;
    }
}

const ProgressStepper = ({ activeStep }) => {
    // const [activeStep, setActiveStep] = useState(0);
    // const [skipped, setSkipped] = useState(new Set());
    const skipped = new Set();

    // const isStepOptional = (step) => {
    //     return step === 2;
    // };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    return (
        <Box sx={{ width: '70%', mt: 5, ml: 3 }}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    // const labelProps = {};
                    // if (isStepOptional(index)) {
                    //     labelProps.optional = (
                    //         <Typography variant="caption">Optional</Typography>
                    //     );
                    // }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={index} />}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    )
}

export default ProgressStepper